import { HomeProject } from '@models/swagger';
import { createAction, props } from '@ngrx/store';

export enum ProjectActions {
  ClearData = '[Flow Data Project] Clear Data',
  UpdateProject = '[Flow Data Project] Update Project',
  EmptyProject = '[Flow Data Project] Empty Project',
  UpdateNonModified = '[Flow Data Project] Update Non Modified',
  EmptyNonModified = '[Flow Data Project] Empty Non Modified',
  WrittenPartnershipCardNumber = '[Flow Data Project] Written Partnership card number',
}

export const ProjectClearData = createAction(ProjectActions.ClearData);

export const ProjectUpdateProject = createAction(ProjectActions.UpdateProject, props<{ data: HomeProject }>());

export const ProjectEmptyProject = createAction(ProjectActions.EmptyProject);

export const ProjectUpdateNonModified = createAction(ProjectActions.UpdateNonModified, props<{ data: HomeProject }>());

export const ProjectEmptyNonModified = createAction(ProjectActions.EmptyNonModified);

export const WrittenPartnershipCardNumber = createAction(
  ProjectActions.WrittenPartnershipCardNumber,
  props<{ data: string }>()
);
